import { render, staticRenderFns } from "./Quiz1.container.vue?vue&type=template&id=3b1c9b72&scoped=true&"
import script from "./Quiz1.container.vue?vue&type=script&lang=js&"
export * from "./Quiz1.container.vue?vue&type=script&lang=js&"
import style0 from "./Quiz1.container.vue?vue&type=style&index=0&id=3b1c9b72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1c9b72",
  null
  
)

export default component.exports